// src/components/RemoveAuthCodeFromUrl.tsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const RemoveAuthCodeFromUrl = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has("code") || params.has("state")) {
      params.delete("code");
      params.delete("state");
      navigate({
        pathname: location.pathname,
        search: params.toString() ? `?${params.toString()}` : "",
      }, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default RemoveAuthCodeFromUrl;